export default __webpack_public_path__ + "files/isee logo-2efab5e59cf5d1e86c708f366e7e9beb.png";